// import React, { useState, useEffect, useRef } from "react";
// import { CheckCircle, User, Mail, X, ChevronDown, Edit3 } from "lucide-react";
// import { useSelector } from "react-redux";

// const BACKEND_URL = process.env.REACT_APP_ENTERPRISE_URL || "http://localhost:4040";

// // ============================================================================
// // 1. SIGNATORY ROW COMPONENT
// // ============================================================================
// const SignatoryRow = ({ sig, index, state, updateState, employeeList, canRemove }) => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isLocked, setIsLocked] = useState(false);
//   const dropdownRef = useRef(null);
//   const connectedContacts = useSelector(
//       (state) => state.ContactArray.ConnectedContact
//     );
//     console.log("connectedContactsDataNNN", connectedContacts)

//   const isDisabled = sig.status === 'SIGNED';

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const filteredEmployees = employeeList.filter((emp) => {
//     const targetRole = (sig.role || "").toLowerCase();
//     const isSpecificRole = ['hr', 'ceo', 'manager'].includes(targetRole);

//     if (isSpecificRole) {
//       const getSafeStr = (val) => {
//         if (!val) return "";
//         if (typeof val === "string") return val.toLowerCase();
//         if (val.name) return String(val.name).toLowerCase();
//         if (val.department_name) return String(val.department_name).toLowerCase();
//         if (val.designation_name) return String(val.designation_name).toLowerCase();
//         return String(val).toLowerCase();
//       };

//       const empDesig = getSafeStr(emp.designation);
//       const empDept = getSafeStr(emp.department);
      
//       let matchesRole = false;
//       if (targetRole === 'hr') {
//         matchesRole = empDesig.includes('hr') || empDesig.includes('human') || empDept.includes('hr') || empDept.includes('human');
//       } else {
//         matchesRole = empDesig.includes(targetRole) || empDept.includes(targetRole);
//       }
      
//       if (!matchesRole) return false; 
//     }

//     if (isLocked) return true;

//     const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.toLowerCase();
//     const searchStr = (sig.name || "").toLowerCase();
    
//     return (
//       fullName.includes(searchStr) ||
//       (emp.email && String(emp.email).toLowerCase().includes(searchStr)) ||
//       (emp.employee_code && String(emp.employee_code).toLowerCase().includes(searchStr))
//     );
//   });

//   const handleSelectEmployee = (emp) => {
//     const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.trim();
//     const newSigs = [...state.signatories];
//     newSigs[index].name = fullName;
//     newSigs[index].email = emp.email || "";
//     updateState("signatories", newSigs);
    
//     setIsLocked(true);
//     setIsDropdownOpen(false);
//   };

//   const handleSelectOther = () => {
//     const newSigs = [...state.signatories];
//     newSigs[index].name = "";
//     newSigs[index].email = "";
//     updateState("signatories", newSigs);
    
//     setIsLocked(false);
//     setIsDropdownOpen(false);
//   };

//   const getProfileImageUrl = (emp) => {
//     let url = emp.profile_url || emp.profileImage || emp.profile_image;
//     if (!url) return null;
//     if (url.startsWith('/uploads')) return `${BACKEND_URL}${url}`;
//     return url;
//   };

//   return (
//     <div style={{
//       backgroundColor: "#f8fafc",
//       border: "1px solid #e2e8f0",
//       borderRadius: "12px",
//       padding: "20px",
//       position: "relative",
//       transition: "all 0.2s",
//       marginBottom: "16px"
//     }}>
//       {/* Header: Role & Status */}
//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         marginBottom: "16px"
//       }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//           <select
//             value={sig.role}
//             onChange={(e) => {
//               const newSigs = [...state.signatories];
//               newSigs[index].role = e.target.value;
//               setIsLocked(false); 
//               updateState("signatories", newSigs);
//             }}
//             disabled={isDisabled}
//             style={{
//               backgroundColor: "white",
//               border: "1px solid #cbd5e1",
//               fontSize: "13px",
//               fontWeight: "600",
//               color: "#334155",
//               borderRadius: "6px",
//               padding: "4px 8px",
//               outline: "none",
//               cursor: isDisabled ? "not-allowed" : "pointer"
//             }}
//           >
//             <option value="Signatory">Signatory</option>
//             <option value="HR">HR</option>
//             <option value="CEO">CEO</option>
//             <option value="Manager">Manager</option>
//             <option value="Employee">Employee</option>
//             <option value="Vendor">Vendor</option>
//           </select>

//           {sig.status === 'SIGNED' ? (
//             <span style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "4px",
//               fontSize: "11px",
//               fontWeight: "bold",
//               textTransform: "uppercase",
//               letterSpacing: "0.5px",
//               color: "#059669",
//               backgroundColor: "#d1fae5",
//               padding: "2px 8px",
//               borderRadius: "999px",
//               border: "1px solid #a7f3d0"
//             }}>
//               <CheckCircle size={12} /> Signed
//             </span>
//           ) : (
//             <span style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "4px",
//               fontSize: "11px",
//               fontWeight: "bold",
//               textTransform: "uppercase",
//               letterSpacing: "0.5px",
//               color: "#d97706",
//               backgroundColor: "#fed7aa",
//               padding: "2px 8px",
//               borderRadius: "999px",
//               border: "1px solid #fde68a"
//             }}>
//               Waiting for signature
//             </span>
//           )}
//         </div>

//         {canRemove && (
//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               const newSigs = state.signatories.filter((_, i) => i !== index);
//               updateState("signatories", newSigs);
//             }}
//             style={{
//               color: "#f87171",
//               backgroundColor: "white",
//               border: "1px solid #e2e8f0",
//               borderRadius: "6px",
//               padding: "4px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               transition: "all 0.2s"
//             }}
//             title="Remove Signatory"
//           >
//             <X size={16} strokeWidth={2.5} />
//           </button>
//         )}
//       </div>

//       {/* Input Fields */}
//       <div style={{
//         display: "grid",
//         gridTemplateColumns: "1fr 1fr",
//         gap: "16px"
//       }}>
//         {/* SMART NAME FIELD */}
//         <div style={{ position: "relative" }} ref={dropdownRef}>
//           <label style={{
//             display: "block",
//             fontSize: "11px",
//             fontWeight: "bold",
//             color: "#334155",
//             marginBottom: "4px"
//           }}>Name</label>
//           <div style={{ position: "relative" }}>
//             <input
//               type="text"
//               placeholder="Search employee or type name"
//               readOnly={isLocked || isDisabled}
//               value={sig.name}
//               onChange={(e) => {
//                 if (isLocked || isDisabled) return;
//                 const newSigs = [...state.signatories];
//                 newSigs[index].name = e.target.value;
//                 updateState("signatories", newSigs);
//                 setIsDropdownOpen(true);
//               }}
//               onFocus={() => { if (!isDisabled) setIsDropdownOpen(true); }}
//               onClick={() => { if (!isDisabled) setIsDropdownOpen(true); }}
//               style={{
//                 width: "100%",
//                 padding: "8px 28px 8px 12px",
//                 fontSize: "13px",
//                 border: "1px solid #cbd5e1",
//                 borderRadius: "8px",
//                 backgroundColor: (isLocked && !isDisabled) ? "#f1f5f9" : (isDisabled ? "#f1f5f9" : "white"),
//                 color: (isLocked || isDisabled) ? "#64748b" : "#0f172a",
//                 outline: "none",
//                 transition: "all 0.2s"
//               }}
//             />
//             <div
//               style={{
//                 position: "absolute",
//                 right: "10px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 cursor: isDisabled ? "not-allowed" : "pointer",
//                 color: "#94a3b8"
//               }}
//               onClick={() => { if (!isDisabled) setIsDropdownOpen(!isDropdownOpen); }}
//             >
//               <ChevronDown size={16} style={{
//                 transition: "transform 0.2s",
//                 transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)"
//               }} />
//             </div>
//           </div>

//           {/* Dropdown List */}
//           {isDropdownOpen && !isDisabled && (
//             <div style={{
//               position: "absolute",
//               zIndex: 60,
//               width: "100%",
//               marginTop: "6px",
//               backgroundColor: "white",
//               border: "1px solid #e2e8f0",
//               borderRadius: "12px",
//               boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
//               maxHeight: "320px",
//               overflow: "hidden"
//             }}>
//               <div style={{
//                 overflowY: "auto",
//                 maxHeight: "224px",
//                 padding: "6px"
//               }}>
//                 {filteredEmployees.length > 0 ? (
//                   filteredEmployees.map((emp) => {
//                     const profileImg = getProfileImageUrl(emp);
//                     return (
//                       <div
//                         key={emp.id}
//                         onClick={() => handleSelectEmployee(emp)}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "12px",
//                           padding: "10px",
//                           cursor: "pointer",
//                           borderRadius: "8px",
//                           transition: "background-color 0.2s"
//                         }}
//                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8fafc"}
//                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                       >
//                         <div style={{
//                           width: "36px",
//                           height: "36px",
//                           borderRadius: "50%",
//                           backgroundColor: "#f1f5f9",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           overflow: "hidden",
//                           border: "1px solid #e2e8f0",
//                           flexShrink: 0
//                         }}>
//                           {profileImg ? (
//                             <img src={profileImg} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                           ) : null}
//                           <User size={16} style={{ display: profileImg ? "none" : "block" }} />
//                         </div>
//                         <div style={{ flex: 1, minWidth: 0 }}>
//                           <p style={{
//                             fontSize: "13px",
//                             fontWeight: "600",
//                             color: "#0f172a",
//                             margin: 0,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap"
//                           }}>
//                             {emp.first_name} {emp.last_name}
//                           </p>
//                           <p style={{
//                             fontSize: "11px",
//                             color: "#64748b",
//                             margin: "2px 0 0 0",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap"
//                           }}>
//                             {emp.email}
//                           </p>
//                         </div>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div style={{
//                     padding: "16px",
//                     textAlign: "center",
//                     fontSize: "12px",
//                     color: "#64748b"
//                   }}>
//                     No matching employees found for "{sig.role}".
//                   </div>
//                 )}
//               </div>

//               {/* Other Option */}
//               <div style={{
//                 borderTop: "1px solid #f1f5f9",
//                 backgroundColor: "#fef9e3",
//                 padding: "6px"
//               }}>
//                 <div
//                   onClick={handleSelectOther}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                     transition: "background-color 0.2s"
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef3c7"}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                 >
//                   <div style={{
//                     width: "36px",
//                     height: "36px",
//                     borderRadius: "50%",
//                     backgroundColor: "white",
//                     border: "1px solid #e2e8f0",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0
//                   }}>
//                     <Edit3 size={16} />
//                   </div>
//                   <div>
//                     <p style={{
//                       fontSize: "13px",
//                       fontWeight: "600",
//                       color: "#0f172a",
//                       margin: 0
//                     }}>
//                       Other (Manual Entry)
//                     </p>
//                     <p style={{
//                       fontSize: "11px",
//                       color: "#64748b",
//                       margin: "2px 0 0 0"
//                     }}>
//                       Clear fields and type custom details
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* EMAIL FIELD */}
//         <div>
//           <label style={{
//             display: "block",
//             fontSize: "11px",
//             fontWeight: "bold",
//             color: "#334155",
//             marginBottom: "4px"
//           }}>
//             Email <span style={{ color: "#ef4444" }}>*</span>
//           </label>
//           <div style={{ position: "relative" }}>
//             <input
//               type="email"
//               placeholder="signer@company.com"
//               readOnly={isLocked || isDisabled}
//               value={sig.email}
//               onChange={(e) => {
//                 if (isLocked || isDisabled) return;
//                 const newSigs = [...state.signatories];
//                 newSigs[index].email = e.target.value;
//                 updateState("signatories", newSigs);
//               }}
//               style={{
//                 width: "100%",
//                 padding: "8px 32px 8px 12px",
//                 fontSize: "13px",
//                 border: "1px solid #cbd5e1",
//                 borderRadius: "8px",
//                 backgroundColor: (isLocked || isDisabled) ? "#f1f5f9" : "white",
//                 color: (isLocked || isDisabled) ? "#64748b" : "#0f172a",
//                 outline: "none"
//               }}
//             />
//             <Mail size={14} style={{
//               position: "absolute",
//               right: "10px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               color: "#94a3b8"
//             }} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ============================================================================
// // 2. SIGNATURE OPTION MAPPER
// // ============================================================================
// const SignatureOption = ({
//   id,
//   label,
//   description,
//   showButton = false,
//   buttonText = "Open",
//   onButtonClick,
//   showUpload = false,
//   disabled = false,
//   showEmailInput = false,
//   state,
//   updateState,
//   fileInputRef,
//   handleFileUpload,
//   isESignVerified,
//   employeeList
// }) => (
//   <div style={{ marginBottom: "16px" }}>
//     <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
//       <div style={{ display: "flex", alignItems: "center", marginTop: "2px" }}>
//         <input
//           id={id}
//           name="signatureType"
//           type="radio"
//           checked={state.signatureType === id}
//           onChange={() => updateState("signatureType", id)}
//           style={{
//             width: "18px",
//             height: "18px",
//             cursor: disabled ? "not-allowed" : "pointer",
//             accentColor: "#2563eb"
//           }}
//           disabled={disabled}
//         />
//       </div>

//       <div style={{ flex: 1 }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
//           <label
//             htmlFor={id}
//             style={{
//               fontSize: "13px",
//               fontWeight: "500",
//               cursor: disabled ? "not-allowed" : "pointer",
//               color: disabled ? "#94a3b8" : "#1e293b"
//             }}
//           >
//             {label}
//           </label>

//           {showButton && !description && state.signatureType === id && (
//             <button
//               onClick={(e) => { e.preventDefault(); onButtonClick(); }}
//               style={{
//                 fontSize: "11px",
//                 backgroundColor: "#2563eb",
//                 color: "white",
//                 padding: "4px 12px",
//                 borderRadius: "6px",
//                 border: "none",
//                 cursor: "pointer",
//                 fontWeight: "500"
//               }}
//             >
//               {buttonText}
//             </button>
//           )}
//         </div>

//         {description && (
//           <p style={{
//             fontSize: "11px",
//             color: "#64748b",
//             marginTop: "4px",
//             marginBottom: 0
//           }}>
//             {description}
//           </p>
//         )}

//         {showButton && description && state.signatureType === id && (
//           <div style={{ marginTop: "12px" }}>
//             {isESignVerified ? (
//               <div style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 color: "#059669",
//                 backgroundColor: "#ecfdf5",
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: "1px solid #a7f3d0",
//                 fontSize: "12px",
//                 fontWeight: "500",
//                 width: "fit-content"
//               }}>
//                 <CheckCircle size={16} />
//                 <span>Verified: {state.esignSignerName || "Signer"}</span>
//               </div>
//             ) : (
//               <button
//                 onClick={(e) => { e.preventDefault(); onButtonClick(); }}
//                 style={{
//                   fontSize: "12px",
//                   backgroundColor: "#2563eb",
//                   color: "white",
//                   padding: "8px 20px",
//                   borderRadius: "8px",
//                   border: "none",
//                   cursor: "pointer",
//                   fontWeight: "500"
//                 }}
//               >
//                 {buttonText}
//               </button>
//             )}
//           </div>
//         )}

//         {id === "draw" && state.signatureType === id && (
//           <div style={{
//             marginTop: "8px",
//             fontSize: "12px",
//             color: "#475569",
//             backgroundColor: "white",
//             border: "1px solid #e2e8f0",
//             borderRadius: "6px",
//             padding: "6px 12px",
//             width: "fit-content"
//           }}>
//             {state.drawnSignature ? (
//               <div>
//                 <span style={{
//                   color: "#059669",
//                   fontSize: "11px",
//                   fontWeight: "500",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "4px",
//                   marginBottom: "8px"
//                 }}>
//                   <CheckCircle size={12} /> Drawn Signature
//                 </span>
//                 <img src={state.drawnSignature} alt="Signature" style={{
//                   height: "48px",
//                   width: "auto",
//                   objectFit: "contain",
//                   backgroundColor: "#f8fafc",
//                   border: "1px solid #f1f5f9",
//                   borderRadius: "4px",
//                   padding: "4px"
//                 }} />
//               </div>
//             ) : (
//               <span style={{ color: "#94a3b8", fontSize: "11px" }}>No signature drawn yet</span>
//             )}
//           </div>
//         )}
//       </div>
//     </div>

//     {showUpload && state.signatureType === id && (
//       <div style={{ marginLeft: "30px", marginTop: "12px" }}>
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           border: "1px solid #cbd5e1",
//           borderRadius: "8px",
//           padding: "8px 12px",
//           backgroundColor: "#f8fafc"
//         }}>
//           <button
//             onClick={(e) => { e.preventDefault(); fileInputRef.current?.click(); }}
//             style={{
//               backgroundColor: "white",
//               border: "1px solid #cbd5e1",
//               borderRadius: "6px",
//               padding: "4px 12px",
//               fontSize: "11px",
//               fontWeight: "500",
//               color: "#334155",
//               cursor: "pointer",
//               marginRight: "12px"
//             }}
//           >
//             Choose File
//           </button>
//           <span style={{
//             fontSize: "12px",
//             color: "#64748b",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap"
//           }}>
//             {state.uploadedSignatureFile ? state.uploadedSignatureFile.name : "no file selected"}
//           </span>
//           <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/png, image/jpeg, image/jpg" onChange={handleFileUpload} />
//         </div>
//         <p style={{
//           fontSize: "10px",
//           color: "#94a3b8",
//           marginTop: "6px",
//           marginLeft: "4px"
//         }}>
//           Supported: PNG, JPG (Max 5MB).
//         </p>

//         {(state.uploadedSignatureUrl || state.uploadedSignatureFile) && (
//           <div style={{
//             marginTop: "12px",
//             fontSize: "12px",
//             backgroundColor: "white",
//             border: "1px solid #e2e8f0",
//             borderRadius: "6px",
//             padding: "6px 12px",
//             width: "fit-content"
//           }}>
//             <span style={{
//               color: "#059669",
//               fontSize: "11px",
//               fontWeight: "500",
//               display: "flex",
//               alignItems: "center",
//               gap: "4px",
//               marginBottom: "8px"
//             }}>
//               <CheckCircle size={12} /> Currently Uploaded
//             </span>
//             <img src={state.uploadedSignatureUrl} alt="Signature" style={{
//               height: "48px",
//               width: "auto",
//               objectFit: "contain",
//               backgroundColor: "#f8fafc",
//               border: "1px solid #f1f5f9",
//               borderRadius: "4px",
//               padding: "4px"
//             }} />
//           </div>
//         )}
//       </div>
//     )}

//     {showEmailInput && state.signatureType === id && (
//       <div style={{ marginLeft: "30px", marginTop: "16px" }}>
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//           {state.signatories?.map((sig, index) => {
//             const canRemove = state.status === 'DRAFT' || sig.status === 'PENDING' || !sig.status;
//             return (
//               <SignatoryRow
//                 key={sig.id || index}
//                 sig={sig}
//                 index={index}
//                 state={state}
//                 updateState={updateState}
//                 employeeList={employeeList}
//                 canRemove={canRemove}
//               />
//             );
//           })}
//         </div>

//         <button
//           onClick={(e) => {
//             e.preventDefault();
//             const newSigs = [...state.signatories, { id: Date.now().toString(), role: 'Signatory', name: '', email: '', status: 'PENDING' }];
//             updateState("signatories", newSigs);
//           }}
//           style={{
//             width: "100%",
//             marginTop: "16px",
//             padding: "12px",
//             border: "2px dashed #93c5fd",
//             backgroundColor: "transparent",
//             color: "#2563eb",
//             fontWeight: "600",
//             fontSize: "12px",
//             borderRadius: "12px",
//             cursor: "pointer",
//             transition: "background-color 0.2s"
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#eff6ff"}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//         >
//           + Add Another Signatory
//         </button>
//       </div>
//     )}
//   </div>
// );

// // ============================================================================
// // 3. PLACEMENT OPTION
// // ============================================================================
// const PlacementOption = ({ id, label, state, updateState }) => (
//   <div style={{ marginBottom: "8px" }}>
//     <div style={{ display: "flex", alignItems: "center" }}>
//       <input
//         id={`place-${id}`}
//         name="signaturePlacement"
//         type="radio"
//         checked={state.signaturePlacement === id}
//         onChange={() => updateState("signaturePlacement", id)}
//         style={{
//           width: "16px",
//           height: "16px",
//           marginRight: "12px",
//           cursor: "pointer",
//           accentColor: "#2563eb"
//         }}
//       />
//       <label htmlFor={`place-${id}`} style={{
//         fontSize: "13px",
//         color: "#475569",
//         cursor: "pointer"
//       }}>
//         {label}
//       </label>
//     </div>

//     {id === "specific" && state.signaturePlacement === "specific" && (
//       <div style={{ marginLeft: "28px", marginTop: "8px", marginBottom: "12px" }}>
//         <input
//           type="number"
//           min="1"
//           placeholder="Page No."
//           style={{
//             width: "96px",
//             border: "1px solid #cbd5e1",
//             borderRadius: "6px",
//             padding: "4px 8px",
//             fontSize: "12px",
//             outline: "none"
//           }}
//           value={state.signaturePagePoint || ""}
//           onChange={(e) => updateState("signaturePagePoint", e.target.value)}
//         />
//       </div>
//     )}
//   </div>
// );

// // ============================================================================
// // 4. MAIN COMPONENT
// // ============================================================================
// export default function SignatureSettingsCard({ state, updateState, openModal, openESignModal }) {
//   const fileInputRef = useRef(null);
//   const hasFetched = useRef(false);
//   const employeeList = [];

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const objectUrl = URL.createObjectURL(file);
//       updateState("uploadedSignatureUrl", objectUrl);
//       updateState("uploadedSignatureFile", file);
//     }
//   };

//   return (
//     <div style={{
//       backgroundColor: "white",
//       border: "1px solid #e2e8f0",
//       borderRadius: "16px",
//       padding: "24px",
//       boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
//     }}>
//       <h2 style={{
//         fontSize: "18px",
//         fontWeight: "600",
//         color: "#1e293b",
//         marginBottom: "24px",
//         marginTop: 0
//       }}>
//         Signature Settings
//       </h2>

//       <div style={{ marginBottom: "32px" }}>
//         <label style={{
//           display: "block",
//           fontSize: "13px",
//           fontWeight: "600",
//           color: "#1e293b",
//           marginBottom: "16px"
//         }}>
//           Signature Type
//         </label>

//         <SignatureOption 
//           id="text" 
//           label="Text Only (Company Name)" 
//           state={state} 
//           updateState={updateState} 
//         />
        
//         <SignatureOption 
//           id="upload" 
//           label="Upload Signature Image" 
//           showUpload={true} 
//           state={state} 
//           updateState={updateState} 
//           fileInputRef={fileInputRef} 
//           handleFileUpload={handleFileUpload} 
//         />
        
//         <SignatureOption 
//           id="draw" 
//           label="Digital Signature (Draw)" 
//           showButton={true} 
//           buttonText="Open Signature Pad" 
//           onButtonClick={openModal} 
//           state={state} 
//           updateState={updateState} 
//         />

//         <SignatureOption
//           id="send_link"
//           disabled={false}
//           label="Send Signing Link to Authorized Signatory"
//           showEmailInput={true}
//           state={state} 
//           updateState={updateState}
//           employeeList={employeeList}
//         />

//         {/* DigiLocker eSign Option */}
//         <div style={{ marginBottom: "16px" }}>
//           <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
//             <div style={{ marginTop: "2px" }}>
//               <input
//                 type="radio"
//                 name="signatureType"
//                 value="esign"
//                 checked={state.signatureType === 'esign'}
//                 onChange={() => updateState('signatureType', 'esign')}
//                 style={{
//                   width: "18px",
//                   height: "18px",
//                   cursor: "pointer",
//                   accentColor: "#2563eb"
//                 }}
//               />
//             </div>
//             <div>
//               <span style={{
//                 fontSize: "13px",
//                 fontWeight: "500",
//                 color: "#1e293b"
//               }}>
//                 DigiLocker eSign
//               </span>
//               <p style={{
//                 fontSize: "11px",
//                 color: "#64748b",
//                 marginTop: "4px",
//                 marginBottom: 0
//               }}>
//                 Redirects to DigiLocker for secure, verified signing.
//               </p>
//             </div>
//           </div>

//           {state.signatureType === 'esign' && (
//             <div style={{ marginLeft: "30px", marginTop: "12px" }}>
//               {state.esignVerified ? (
//                 <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                   <div style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: "6px",
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     backgroundColor: "#ecfdf5",
//                     border: "1px solid #a7f3d0",
//                     color: "#059669",
//                     fontSize: "12px",
//                     fontWeight: "500"
//                   }}>
//                     <CheckCircle size={14} />
//                     Verified: {state.esignSignerName}
//                   </div>
//                   {state.status === 'DRAFT' && (
//                     <button
//                       type="button"
//                       onClick={() => {
//                         updateState("esignVerified", false);
//                         updateState("esignSignerName", null);
//                         updateState("esignDate", null);
//                         updateState("esignProvider", null);
//                         updateState("esignReference", null);
//                       }}
//                       style={{
//                         fontSize: "11px",
//                         fontWeight: "500",
//                         color: "#e11d48",
//                         backgroundColor: "#ffe4e6",
//                         border: "1px solid #fecdd3",
//                         borderRadius: "6px",
//                         padding: "4px 12px",
//                         cursor: "pointer"
//                       }}
//                     >
//                       <X size={12} style={{ display: "inline", marginRight: "4px" }} /> Remove
//                     </button>
//                   )}
//                 </div>
//               ) : (
//                 <button
//                   type="button"
//                   onClick={(e) => { e.preventDefault(); openESignModal(); }}
//                   style={{
//                     padding: "8px 20px",
//                     backgroundColor: "#2563eb",
//                     color: "white",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     borderRadius: "8px",
//                     border: "none",
//                     cursor: "pointer"
//                   }}
//                 >
//                   Proceed to DigiLocker
//                 </button>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       <div>
//         <label style={{
//           display: "block",
//           fontSize: "13px",
//           fontWeight: "600",
//           color: "#1e293b",
//           marginBottom: "16px"
//         }}>
//           Signature Placement
//         </label>
//         <div>
//           <PlacementOption id="all_pages" label="All Pages" state={state} updateState={updateState} />
//           <PlacementOption id="first_page" label="First Page Only" state={state} updateState={updateState} />
//           <PlacementOption id="last_page" label="Last Page Only" state={state} updateState={updateState} />
//           <PlacementOption id="first_last" label="First and Last Page" state={state} updateState={updateState} />
//         </div>
//       </div>
//     </div>
//   );
// }




import React, { useState, useEffect, useRef } from "react";
import { CheckCircle, User, Mail, X, ChevronDown, Edit3 } from "lucide-react";
import { useSelector } from "react-redux";

const BACKEND_URL = process.env.REACT_APP_ENTERPRISE_URL || "http://localhost:4040";

// ============================================================================
// 1. SIGNATORY ROW COMPONENT
// ============================================================================
const SignatoryRow = ({ sig, index, state, updateState, employeeList, canRemove }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const dropdownRef = useRef(null);
  const connectedContacts = useSelector(
      (state) => state.ContactArray.ConnectedContact
    );
    console.log("connectedContactsDataNNN", connectedContacts)

  const isDisabled = sig.status === 'SIGNED';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredEmployees = employeeList.filter((emp) => {
    const targetRole = (sig.role || "").toLowerCase();
    const isSpecificRole = ['hr', 'ceo', 'manager'].includes(targetRole);

    if (isSpecificRole) {
      const getSafeStr = (val) => {
        if (!val) return "";
        if (typeof val === "string") return val.toLowerCase();
        if (val.name) return String(val.name).toLowerCase();
        if (val.department_name) return String(val.department_name).toLowerCase();
        if (val.designation_name) return String(val.designation_name).toLowerCase();
        return String(val).toLowerCase();
      };

      const empDesig = getSafeStr(emp.designation);
      const empDept = getSafeStr(emp.department);
      
      let matchesRole = false;
      if (targetRole === 'hr') {
        matchesRole = empDesig.includes('hr') || empDesig.includes('human') || empDept.includes('hr') || empDept.includes('human');
      } else {
        matchesRole = empDesig.includes(targetRole) || empDept.includes(targetRole);
      }
      
      if (!matchesRole) return false; 
    }

    if (isLocked) return true;

    const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.toLowerCase();
    const searchStr = (sig.name || "").toLowerCase();
    
    return (
      fullName.includes(searchStr) ||
      (emp.email && String(emp.email).toLowerCase().includes(searchStr)) ||
      (emp.employee_code && String(emp.employee_code).toLowerCase().includes(searchStr)) ||
      (emp.phone_no && String(emp.phone_no).toLowerCase().includes(searchStr)) ||
      (emp.unique_id && String(emp.unique_id).toLowerCase().includes(searchStr))
    );
  });

  const handleSelectEmployee = (emp) => {
    const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.trim();
    const newSigs = [...state.signatories];
    newSigs[index].name = fullName;
    newSigs[index].email = emp.email || "";
    updateState("signatories", newSigs);
    
    setIsLocked(true);
    setIsDropdownOpen(false);
  };

  const handleSelectOther = () => {
    const newSigs = [...state.signatories];
    newSigs[index].name = "";
    newSigs[index].email = "";
    updateState("signatories", newSigs);
    
    setIsLocked(false);
    setIsDropdownOpen(false);
  };

  const getProfileImageUrl = (emp) => {
    let url = emp.profile_url || emp.profileImage || emp.profile_image;
    if (!url) return null;
    if (url.startsWith('/uploads')) return `${BACKEND_URL}${url}`;
    return url;
  };

  return (
    <div style={{
      backgroundColor: "#f8fafc",
      border: "1px solid #e2e8f0",
      borderRadius: "12px",
      padding: "20px",
      position: "relative",
      transition: "all 0.2s",
      marginBottom: "16px"
    }}>
      {/* Header: Role & Status */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <select
            value={sig.role}
            onChange={(e) => {
              const newSigs = [...state.signatories];
              newSigs[index].role = e.target.value;
              setIsLocked(false); 
              updateState("signatories", newSigs);
            }}
            disabled={isDisabled}
            style={{
              backgroundColor: "white",
              border: "1px solid #cbd5e1",
              fontSize: "13px",
              fontWeight: "600",
              color: "#334155",
              borderRadius: "6px",
              padding: "4px 8px",
              outline: "none",
              cursor: isDisabled ? "not-allowed" : "pointer"
            }}
          >
            <option value="Signatory">Signatory</option>
            <option value="HR">HR</option>
            <option value="CEO">CEO</option>
            <option value="Manager">Manager</option>
            <option value="Employee">Employee</option>
            <option value="Vendor">Vendor</option>
          </select>

          {sig.status === 'SIGNED' ? (
            <span style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              color: "#059669",
              backgroundColor: "#d1fae5",
              padding: "2px 8px",
              borderRadius: "999px",
              border: "1px solid #a7f3d0"
            }}>
              <CheckCircle size={12} /> Signed
            </span>
          ) : (
            <span style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              color: "#d97706",
              backgroundColor: "#fed7aa",
              padding: "2px 8px",
              borderRadius: "999px",
              border: "1px solid #fde68a"
            }}>
              Waiting for signature
            </span>
          )}
        </div>

        {canRemove && (
          <button
            onClick={(e) => {
              e.preventDefault();
              const newSigs = state.signatories.filter((_, i) => i !== index);
              updateState("signatories", newSigs);
            }}
            style={{
              color: "#f87171",
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              padding: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s"
            }}
            title="Remove Signatory"
          >
            <X size={16} strokeWidth={2.5} />
          </button>
        )}
      </div>

      {/* Input Fields */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "16px"
      }}>
        {/* SMART NAME FIELD */}
        <div style={{ position: "relative" }} ref={dropdownRef}>
          <label style={{
            display: "block",
            fontSize: "11px",
            fontWeight: "bold",
            color: "#334155",
            marginBottom: "4px"
          }}>Name</label>
          <div style={{ position: "relative" }}>
            <input
              type="text"
              placeholder="Search employee or type name"
              readOnly={isLocked || isDisabled}
              value={sig.name}
              onChange={(e) => {
                if (isLocked || isDisabled) return;
                const newSigs = [...state.signatories];
                newSigs[index].name = e.target.value;
                updateState("signatories", newSigs);
                setIsDropdownOpen(true);
              }}
              onFocus={() => { if (!isDisabled) setIsDropdownOpen(true); }}
              onClick={() => { if (!isDisabled) setIsDropdownOpen(true); }}
              style={{
                width: "100%",
                padding: "8px 28px 8px 12px",
                fontSize: "13px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                backgroundColor: (isLocked && !isDisabled) ? "#f1f5f9" : (isDisabled ? "#f1f5f9" : "white"),
                color: (isLocked || isDisabled) ? "#64748b" : "#0f172a",
                outline: "none",
                transition: "all 0.2s"
              }}
            />
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: isDisabled ? "not-allowed" : "pointer",
                color: "#94a3b8"
              }}
              onClick={() => { if (!isDisabled) setIsDropdownOpen(!isDropdownOpen); }}
            >
              <ChevronDown size={16} style={{
                transition: "transform 0.2s",
                transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)"
              }} />
            </div>
          </div>

          {/* Dropdown List */}
          {isDropdownOpen && !isDisabled && (
            <div style={{
              position: "absolute",
              zIndex: 60,
              width: "100%",
              marginTop: "6px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
              maxHeight: "320px",
              overflow: "hidden"
            }}>
              <div style={{
                overflowY: "auto",
                maxHeight: "224px",
                padding: "6px"
              }}>
                {filteredEmployees.length > 0 ? (
                  filteredEmployees.map((emp) => {
                    const profileImg = getProfileImageUrl(emp);
                    return (
                      <div
                        key={emp.id || emp.contact_ref_id}
                        onClick={() => handleSelectEmployee(emp)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "8px",
                          transition: "background-color 0.2s"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8fafc"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                      >
                        <div style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          backgroundColor: "#f1f5f9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          flexShrink: 0
                        }}>
                          {profileImg ? (
                            <img src={profileImg} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          ) : (
                            <User size={16} />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#0f172a",
                            margin: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {emp.first_name} {emp.last_name}
                          </p>
                          <p style={{
                            fontSize: "11px",
                            color: "#64748b",
                            margin: "2px 0 0 0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {emp.email || emp.phone_no}
                          </p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{
                    padding: "16px",
                    textAlign: "center",
                    fontSize: "12px",
                    color: "#64748b"
                  }}>
                    No matching employees found for "{sig.role}".
                  </div>
                )}
              </div>

              {/* Other Option */}
              <div style={{
                borderTop: "1px solid #f1f5f9",
                backgroundColor: "#fef9e3",
                padding: "6px"
              }}>
                <div
                  onClick={handleSelectOther}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef3c7"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                >
                  <div style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    border: "1px solid #e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                  }}>
                    <Edit3 size={16} />
                  </div>
                  <div>
                    <p style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#0f172a",
                      margin: 0
                    }}>
                      Other (Manual Entry)
                    </p>
                    <p style={{
                      fontSize: "11px",
                      color: "#64748b",
                      margin: "2px 0 0 0"
                    }}>
                      Clear fields and type custom details
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* EMAIL FIELD */}
        <div>
          <label style={{
            display: "block",
            fontSize: "11px",
            fontWeight: "bold",
            color: "#334155",
            marginBottom: "4px"
          }}>
            Email <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <div style={{ position: "relative" }}>
            <input
              type="email"
              placeholder="signer@company.com"
              readOnly={isLocked || isDisabled}
              value={sig.email}
              onChange={(e) => {
                if (isLocked || isDisabled) return;
                const newSigs = [...state.signatories];
                newSigs[index].email = e.target.value;
                updateState("signatories", newSigs);
              }}
              style={{
                width: "100%",
                padding: "8px 32px 8px 12px",
                fontSize: "13px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                backgroundColor: (isLocked || isDisabled) ? "#f1f5f9" : "white",
                color: (isLocked || isDisabled) ? "#64748b" : "#0f172a",
                outline: "none"
              }}
            />
            <Mail size={14} style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#94a3b8"
            }} />
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================================================
// 2. SIGNATURE OPTION MAPPER
// ============================================================================
const SignatureOption = ({
  id,
  label,
  description,
  showButton = false,
  buttonText = "Open",
  onButtonClick,
  showUpload = false,
  disabled = false,
  showEmailInput = false,
  state,
  updateState,
  fileInputRef,
  handleFileUpload,
  isESignVerified,
  employeeList
}) => (
  <div style={{ marginBottom: "16px" }}>
    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
      <div style={{ display: "flex", alignItems: "center", marginTop: "2px" }}>
        <input
          id={id}
          name="signatureType"
          type="radio"
          checked={state.signatureType === id}
          onChange={() => updateState("signatureType", id)}
          style={{
            width: "18px",
            height: "18px",
            cursor: disabled ? "not-allowed" : "pointer",
            accentColor: "#2563eb"
          }}
          disabled={disabled}
        />
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
          <label
            htmlFor={id}
            style={{
              fontSize: "13px",
              fontWeight: "500",
              cursor: disabled ? "not-allowed" : "pointer",
              color: disabled ? "#94a3b8" : "#1e293b"
            }}
          >
            {label}
          </label>

          {showButton && !description && state.signatureType === id && (
            <button
              onClick={(e) => { e.preventDefault(); onButtonClick(); }}
              style={{
                fontSize: "11px",
                backgroundColor: "#2563eb",
                color: "white",
                padding: "4px 12px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                fontWeight: "500"
              }}
            >
              {buttonText}
            </button>
          )}
        </div>

        {description && (
          <p style={{
            fontSize: "11px",
            color: "#64748b",
            marginTop: "4px",
            marginBottom: 0
          }}>
            {description}
          </p>
        )}

        {showButton && description && state.signatureType === id && (
          <div style={{ marginTop: "12px" }}>
            {isESignVerified ? (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#059669",
                backgroundColor: "#ecfdf5",
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #a7f3d0",
                fontSize: "12px",
                fontWeight: "500",
                width: "fit-content"
              }}>
                <CheckCircle size={16} />
                <span>Verified: {state.esignSignerName || "Signer"}</span>
              </div>
            ) : (
              <button
                onClick={(e) => { e.preventDefault(); onButtonClick(); }}
                style={{
                  fontSize: "12px",
                  backgroundColor: "#2563eb",
                  color: "white",
                  padding: "8px 20px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500"
                }}
              >
                {buttonText}
              </button>
            )}
          </div>
        )}

        {id === "draw" && state.signatureType === id && (
          <div style={{
            marginTop: "8px",
            fontSize: "12px",
            color: "#475569",
            backgroundColor: "white",
            border: "1px solid #e2e8f0",
            borderRadius: "6px",
            padding: "6px 12px",
            width: "fit-content"
          }}>
            {state.drawnSignature ? (
              <div>
                <span style={{
                  color: "#059669",
                  fontSize: "11px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  marginBottom: "8px"
                }}>
                  <CheckCircle size={12} /> Drawn Signature
                </span>
                <img src={state.drawnSignature} alt="Signature" style={{
                  height: "48px",
                  width: "auto",
                  objectFit: "contain",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #f1f5f9",
                  borderRadius: "4px",
                  padding: "4px"
                }} />
              </div>
            ) : (
              <span style={{ color: "#94a3b8", fontSize: "11px" }}>No signature drawn yet</span>
            )}
          </div>
        )}
      </div>
    </div>

    {showUpload && state.signatureType === id && (
      <div style={{ marginLeft: "30px", marginTop: "12px" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          padding: "8px 12px",
          backgroundColor: "#f8fafc"
        }}>
          <button
            onClick={(e) => { e.preventDefault(); fileInputRef.current?.click(); }}
            style={{
              backgroundColor: "white",
              border: "1px solid #cbd5e1",
              borderRadius: "6px",
              padding: "4px 12px",
              fontSize: "11px",
              fontWeight: "500",
              color: "#334155",
              cursor: "pointer",
              marginRight: "12px"
            }}
          >
            Choose File
          </button>
          <span style={{
            fontSize: "12px",
            color: "#64748b",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            {state.uploadedSignatureFile ? state.uploadedSignatureFile.name : "no file selected"}
          </span>
          <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/png, image/jpeg, image/jpg" onChange={handleFileUpload} />
        </div>
        <p style={{
          fontSize: "10px",
          color: "#94a3b8",
          marginTop: "6px",
          marginLeft: "4px"
        }}>
          Supported: PNG, JPG (Max 5MB).
        </p>

        {(state.uploadedSignatureUrl || state.uploadedSignatureFile) && (
          <div style={{
            marginTop: "12px",
            fontSize: "12px",
            backgroundColor: "white",
            border: "1px solid #e2e8f0",
            borderRadius: "6px",
            padding: "6px 12px",
            width: "fit-content"
          }}>
            <span style={{
              color: "#059669",
              fontSize: "11px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginBottom: "8px"
            }}>
              <CheckCircle size={12} /> Currently Uploaded
            </span>
            <img src={state.uploadedSignatureUrl} alt="Signature" style={{
              height: "48px",
              width: "auto",
              objectFit: "contain",
              backgroundColor: "#f8fafc",
              border: "1px solid #f1f5f9",
              borderRadius: "4px",
              padding: "4px"
            }} />
          </div>
        )}
      </div>
    )}

    {showEmailInput && state.signatureType === id && (
      <div style={{ marginLeft: "30px", marginTop: "16px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {state.signatories?.map((sig, index) => {
            const canRemove = state.status === 'DRAFT' || sig.status === 'PENDING' || !sig.status;
            return (
              <SignatoryRow
                key={sig.id || index}
                sig={sig}
                index={index}
                state={state}
                updateState={updateState}
                employeeList={employeeList}
                canRemove={canRemove}
              />
            );
          })}
        </div>

        <button
          onClick={(e) => {
            e.preventDefault();
            const newSigs = [...state.signatories, { id: Date.now().toString(), role: 'Signatory', name: '', email: '', status: 'PENDING' }];
            updateState("signatories", newSigs);
          }}
          style={{
            width: "100%",
            marginTop: "16px",
            padding: "12px",
            border: "2px dashed #93c5fd",
            backgroundColor: "transparent",
            color: "#2563eb",
            fontWeight: "600",
            fontSize: "12px",
            borderRadius: "12px",
            cursor: "pointer",
            transition: "background-color 0.2s"
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#eff6ff"}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
        >
          + Add Another Signatory
        </button>
      </div>
    )}
  </div>
);

// ============================================================================
// 3. PLACEMENT OPTION
// ============================================================================
const PlacementOption = ({ id, label, state, updateState }) => (
  <div style={{ marginBottom: "8px" }}>
    <div style={{ display: "flex", alignItems: "center" }}>
      <input
        id={`place-${id}`}
        name="signaturePlacement"
        type="radio"
        checked={state.signaturePlacement === id}
        onChange={() => updateState("signaturePlacement", id)}
        style={{
          width: "16px",
          height: "16px",
          marginRight: "12px",
          cursor: "pointer",
          accentColor: "#2563eb"
        }}
      />
      <label htmlFor={`place-${id}`} style={{
        fontSize: "13px",
        color: "#475569",
        cursor: "pointer"
      }}>
        {label}
      </label>
    </div>

    {id === "specific" && state.signaturePlacement === "specific" && (
      <div style={{ marginLeft: "28px", marginTop: "8px", marginBottom: "12px" }}>
        <input
          type="number"
          min="1"
          placeholder="Page No."
          style={{
            width: "96px",
            border: "1px solid #cbd5e1",
            borderRadius: "6px",
            padding: "4px 8px",
            fontSize: "12px",
            outline: "none"
          }}
          value={state.signaturePagePoint || ""}
          onChange={(e) => updateState("signaturePagePoint", e.target.value)}
        />
      </div>
    )}
  </div>
);

// ============================================================================
// 4. MAIN COMPONENT
// ============================================================================
export default function SignatureSettingsCard({ state, updateState, openModal, openESignModal }) {
  const fileInputRef = useRef(null);
  const hasFetched = useRef(false);
  
  // Replace empty array with connected contacts from Redux
  const connectedContacts = useSelector(
    (state) => state.ContactArray.ConnectedContact
  );
  
  // Map connected contacts to the expected employeeList format
  const employeeList = connectedContacts?.map(contact => ({
    id: contact.contact_ref_id || contact.id,
    first_name: contact.first_name || "",
    last_name: contact.last_name || "",
    email: contact.email || "",
    phone_no: contact.phone_no || "",
    profile_url: contact.profile_url || "",
    designation: contact.designation || "",
    department: contact.department || "",
    employee_code: contact.unique_id || "",
    company: contact.company || "",
    title: contact.title || "",
    nickname: contact.nickname || "",
    field_of_study: contact.field_of_study || "",
    institute: contact.institute || "",
    profession_department: contact.profession_department || "",
    website: contact.website || "",
    is_favourite: contact.is_favourite || 0,
    is_verified: contact.is_verified || 0,
    status: contact.status || "",
    relationship_type: contact.relationship_type || "",
    contact_ref_id: contact.contact_ref_id || null,
    user_ref_id: contact.user_ref_id || null,
    created_at: contact.created_at || "",
    updated_at: contact.updated_at || ""
  })) || [];

  console.log("Mapped employeeList:", employeeList);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      updateState("uploadedSignatureUrl", objectUrl);
      updateState("uploadedSignatureFile", file);
    }
  };

  return (
    <div style={{
      backgroundColor: "white",
      border: "1px solid #e2e8f0",
      borderRadius: "16px",
      padding: "24px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
    }}>
      <h2 style={{
        fontSize: "18px",
        fontWeight: "600",
        color: "#1e293b",
        marginBottom: "24px",
        marginTop: 0
      }}>
        Signature Settings
      </h2>

      <div style={{ marginBottom: "32px" }}>
        <label style={{
          display: "block",
          fontSize: "13px",
          fontWeight: "600",
          color: "#1e293b",
          marginBottom: "16px"
        }}>
          Signature Type
        </label>

        <SignatureOption 
          id="text" 
          label="Text Only (Company Name)" 
          state={state} 
          updateState={updateState} 
        />
        
        <SignatureOption 
          id="upload" 
          label="Upload Signature Image" 
          showUpload={true} 
          state={state} 
          updateState={updateState} 
          fileInputRef={fileInputRef} 
          handleFileUpload={handleFileUpload} 
        />
        
        <SignatureOption 
          id="draw" 
          label="Digital Signature (Draw)" 
          showButton={true} 
          buttonText="Open Signature Pad" 
          onButtonClick={openModal} 
          state={state} 
          updateState={updateState} 
        />

        <SignatureOption
          id="send_link"
          disabled={false}
          label="Send Signing Link to Authorized Signatory"
          showEmailInput={true}
          state={state} 
          updateState={updateState}
          employeeList={employeeList}
        />

        {/* DigiLocker eSign Option */}
        <div style={{ marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
            <div style={{ marginTop: "2px" }}>
              <input
                type="radio"
                name="signatureType"
                value="esign"
                checked={state.signatureType === 'esign'}
                onChange={() => updateState('signatureType', 'esign')}
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  accentColor: "#2563eb"
                }}
              />
            </div>
            <div>
              <span style={{
                fontSize: "13px",
                fontWeight: "500",
                color: "#1e293b"
              }}>
                DigiLocker eSign
              </span>
              <p style={{
                fontSize: "11px",
                color: "#64748b",
                marginTop: "4px",
                marginBottom: 0
              }}>
                Redirects to DigiLocker for secure, verified signing.
              </p>
            </div>
          </div>

          {state.signatureType === 'esign' && (
            <div style={{ marginLeft: "30px", marginTop: "12px" }}>
              {state.esignVerified ? (
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    borderRadius: "8px",
                    backgroundColor: "#ecfdf5",
                    border: "1px solid #a7f3d0",
                    color: "#059669",
                    fontSize: "12px",
                    fontWeight: "500"
                  }}>
                    <CheckCircle size={14} />
                    Verified: {state.esignSignerName}
                  </div>
                  {state.status === 'DRAFT' && (
                    <button
                      type="button"
                      onClick={() => {
                        updateState("esignVerified", false);
                        updateState("esignSignerName", null);
                        updateState("esignDate", null);
                        updateState("esignProvider", null);
                        updateState("esignReference", null);
                      }}
                      style={{
                        fontSize: "11px",
                        fontWeight: "500",
                        color: "#e11d48",
                        backgroundColor: "#ffe4e6",
                        border: "1px solid #fecdd3",
                        borderRadius: "6px",
                        padding: "4px 12px",
                        cursor: "pointer"
                      }}
                    >
                      <X size={12} style={{ display: "inline", marginRight: "4px" }} /> Remove
                    </button>
                  )}
                </div>
              ) : (
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); openESignModal(); }}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#2563eb",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "500",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Proceed to DigiLocker
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      <div>
        <label style={{
          display: "block",
          fontSize: "13px",
          fontWeight: "600",
          color: "#1e293b",
          marginBottom: "16px"
        }}>
          Signature Placement
        </label>
        <div>
          <PlacementOption id="all_pages" label="All Pages" state={state} updateState={updateState} />
          <PlacementOption id="first_page" label="First Page Only" state={state} updateState={updateState} />
          <PlacementOption id="last_page" label="Last Page Only" state={state} updateState={updateState} />
          <PlacementOption id="first_last" label="First and Last Page" state={state} updateState={updateState} />
        </div>
      </div>
    </div>
  );
}